import { useEffect, useState } from 'react'
import { fetchAiReceptionistActorApi } from '@services/api/ai-receptionist-settings.api'
import { useAppSelector } from '@store/hooks'

const actorByClinic = new Map<string, string | null>()
const inflightByClinic = new Map<string, Promise<string | null>>()

const loadActorId = (clinicId: string): Promise<string | null> => {
  const existing = inflightByClinic.get(clinicId)
  if (existing) return existing

  const request = fetchAiReceptionistActorApi()
    .then((response) => response.data.user_id || null)
    .catch(() => null)
    .then((userId) => {
      actorByClinic.set(clinicId, userId)
      inflightByClinic.delete(clinicId)
      return userId
    })
  inflightByClinic.set(clinicId, request)
  return request
}

/** User id stored on records the AI receptionist creates, updates, or handles. */
export const useAiReceptionistActorId = (): string | null => {
  const clinicId = useAppSelector(
    (state) => state.clinic.selectedClinic?.clinic_id ?? '',
  )
  const [actorId, setActorId] = useState<string | null>(() =>
    clinicId ? (actorByClinic.get(clinicId) ?? null) : null,
  )

  useEffect(() => {
    if (!clinicId) {
      setActorId(null)
      return
    }
    if (actorByClinic.has(clinicId)) {
      setActorId(actorByClinic.get(clinicId) ?? null)
      return
    }

    let cancelled = false
    setActorId(null)
    void loadActorId(clinicId).then((userId) => {
      if (!cancelled) setActorId(userId)
    })
    return () => {
      cancelled = true
    }
  }, [clinicId])

  return actorId
}
